import React from 'react';
import styles from './Layout.module.scss';
import cs from 'classnames';
import ScreenLink from '../ScreenLink';
import Accordion from '../../Accordion/Accordion/Accordion';
import LayoutItem from '../LayoutItem';
import LayoutItems from '../LayoutItems';
import AccordionLayoutItem from '../AccordionLayoutItem';
import ListItem from '../ListItem';
import kebab from '../../utils/kebab';
import uuid from '../../utils/uuid';
export default function Layout(_ref) {
  var size = _ref.size,
    ariaLabelledBy = _ref.ariaLabelledBy,
    _ref$useAccordions = _ref.useAccordions,
    useAccordions = _ref$useAccordions === void 0 ? true : _ref$useAccordions,
    items = _ref.screens,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 0 : _ref$level,
    _ref$ScreenLinkCompon = _ref.ScreenLinkComponent,
    ScreenLinkComponent = _ref$ScreenLinkCompon === void 0 ? ScreenLink : _ref$ScreenLinkCompon;
  return items ? /*#__PURE__*/React.createElement("ul", {
    "aria-labelledby": ariaLabelledBy,
    className: cs(styles.list, 'component-sets auto-main-menu-screens-list')
  }, /*#__PURE__*/React.createElement(Accordion, null, items.map(function (item) {
    switch (item.type) {
      case 'screen':
        return /*#__PURE__*/React.createElement(ScreenLinkComponent, {
          key: item.screenId,
          id: item.screenId,
          name: item.name,
          level: level,
          href: item.href,
          item: item
        });
      case 'text':
        return /*#__PURE__*/React.createElement(ListItem, {
          key: kebab(item.text),
          className: styles.item,
          html: item.text
        });
      case 'group':
        var key = kebab(item.name);
        var id = "".concat(key, "-").concat(uuid());
        if (level === 0 && item.orientation === 'vertical' && useAccordions) {
          return /*#__PURE__*/React.createElement(AccordionLayoutItem, {
            key: key,
            id: id,
            name: item.name
          }, /*#__PURE__*/React.createElement(LayoutItems, {
            size: size,
            orientation: item.orientation,
            level: level,
            ScreenLinkComponent: ScreenLinkComponent
          }, item.children));
        } else {
          return /*#__PURE__*/React.createElement(LayoutItem, {
            key: key,
            id: id,
            name: item.name,
            orientation: item.orientation,
            level: level
          }, /*#__PURE__*/React.createElement(LayoutItems, {
            size: size,
            labelledby: id,
            orientation: item.orientation,
            level: level,
            ScreenLinkComponent: ScreenLinkComponent
          }, item.children));
        }
      default:
        return null;
    }
  }))) : null;
}